module.exports = __webpack_public_path__ + "static/img/tick1.742f7ea2.gif";